import type * as TooltipPrimitive from '@radix-ui/react-tooltip'
import type * as React from 'react'

import {
  TooltipContent,
  TooltipTrigger,
  Tooltip as UiTooltip,
} from '@/components/ui/tooltip'

// Long open delay so mouse travel across the dense dashboard doesn't
// flash tooltips (LG-181). Radix Root's delayDuration overrides the
// provider default baked into the ui wrapper.
export const COACHING_TOOLTIP_DELAY_MS = 2000

function Tooltip(
  props: React.ComponentProps<typeof TooltipPrimitive.Root>,
): React.ReactElement {
  return <UiTooltip delayDuration={COACHING_TOOLTIP_DELAY_MS} {...props} />
}

export { Tooltip, TooltipContent, TooltipTrigger }
